import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";
import { IFormQualifierAttribute } from "../form/FormQualifierAttribute";

export interface TFormSectionQualifier {
  additionalComment: string;
  aggregateFunction: string;
  formSectionId: number;
  label: string;
  labelVisible: boolean;
  orderNumber: number;
  orderNumberVisible: boolean;
  formSectionQualifierId: number;
  qualifierId: number;
  qualifierName: string;
  tooltip: string;
  required: boolean;
  qualifierCode: string;
  width: number;
}

export interface IFormSectionQualifier extends TFormSectionQualifier {
  attributes: IFormQualifierAttribute[];
}

const FormSectionQualifier = Model(
  (model: IFormSectionQualifier): IFormSectionQualifier => {
    const _formSectionQualifier: TFormSectionQualifier = Object.assign(
      {},
      model
    );

    let create = (
      formSectionQualifier: IFormSectionQualifier
    ): IFormSectionQualifier => {
      let obj = ValidatableObject(formSectionQualifier);
      return obj;
    };

    let _attributes: IFormQualifierAttribute[] = [];

    let formSectionQualifier = {
      get additionalComment() {
        return _formSectionQualifier.additionalComment;
      },
      set additionalComment(value) {
        _formSectionQualifier.additionalComment = value;
      },
      get aggregateFunction() {
        return _formSectionQualifier.aggregateFunction;
      },
      set aggregateFunction(value) {
        _formSectionQualifier.aggregateFunction = value;
      },
      get formSectionId() {
        return _formSectionQualifier.formSectionId;
      },
      set formSectionId(value) {
        _formSectionQualifier.formSectionId = value;
      },
      get label() {
        return _formSectionQualifier.label;
      },
      set label(value) {
        _formSectionQualifier.label = value;
      },
      get labelVisible() {
        return _formSectionQualifier.labelVisible;
      },
      set labelVisible(value) {
        _formSectionQualifier.labelVisible = value;
      },
      get orderNumber() {
        return _formSectionQualifier.orderNumber;
      },
      set orderNumber(value) {
        _formSectionQualifier.orderNumber = value;
      },
      get orderNumberVisible() {
        return _formSectionQualifier.orderNumberVisible;
      },
      set orderNumberVisible(value) {
        _formSectionQualifier.orderNumberVisible = value;
      },
      get formSectionQualifierId() {
        return _formSectionQualifier.formSectionQualifierId;
      },
      set formSectionQualifierId(value) {
        _formSectionQualifier.formSectionQualifierId = value;
      },
      get qualifierId() {
        return _formSectionQualifier.qualifierId;
      },
      set qualifierId(value) {
        _formSectionQualifier.qualifierId = value;
      },
      get qualifierName() {
        return _formSectionQualifier.qualifierName;
      },
      set qualifierName(value) {
        _formSectionQualifier.qualifierName = value;
      },
      get tooltip() {
        return _formSectionQualifier.tooltip;
      },
      set tooltip(value) {
        _formSectionQualifier.tooltip = value;
      },
      get attributes() {
        return _attributes;
      },
      set attributes(values) {
        _attributes = values;
      },
      get required() {
        return _formSectionQualifier.required;
      },
      set required(value) {
        _formSectionQualifier.required = value;
      },
      get qualifierCode() {
        return _formSectionQualifier.qualifierCode;
      },
      set qualifierCode(value) {
        _formSectionQualifier.qualifierCode = value;
      },
      get width() {
        return _formSectionQualifier.width;
      },
      set width(value) {
        _formSectionQualifier.width = value;
      }
    };
    return create(formSectionQualifier);
  }
);

export default FormSectionQualifier;
